<template>
  <b-container fluid>
    <b-row>

      <b-col v-if="!domain.includes('parquimetro.gobinet.mx')">
        <b-row align-h="center" align="center">
          <b-col cols="11" class="mt-5 ">
            <h5>Ingrese el nombre del municipio</h5>
          </b-col>
        </b-row>
        <b-row align-h="center" align="center">
          <b-col class="mb-5" cols="11" md="6" lg="4">
            <b-form-input v-model="municipioIn" placeholder="Nombre del municipio"></b-form-input>
          </b-col>
        </b-row>
        <b-row align-h="center" align="center">
          <b-col class=" mb-5" cols="11" md="6" lg="4">
            <router-link :to="this.municipioIn.trim().toLowerCase()+'/login'">
              <div style="font-size:25px;" >
                Continuar
              </div>
            </router-link>
          </b-col>
        </b-row>
        <!-- <b-row align-h="center" align="center">
          <b-col class=" mb-5" cols="11" md="6" lg="4">
            <router-link :to="this.municipioIn.trim().toLowerCase()+'/portalcontribuyente'">
              <div style="font-size:25px;" >
                Continuar a pagos en línea
              </div>
            </router-link>
          </b-col>
        </b-row> -->
      </b-col>

      <b-col cols="12" v-if="domain.includes('parquimetro.gobinet.mx')">
        <b-row align-h="center" align="center">
          <b-col class=" mb-5" cols="11" md="6" lg="4">
            <h4>Pago de parquímetro</h4>
            <a style="font-size:25px;" :href="'https://parquimetro.gobinet.mx/parqteotihuacan/parquimetro'">
              Click para continuar 
            </a>
          </b-col>
        </b-row>
      </b-col>

      
    </b-row>
    
    <b-row align-h="center">
      <b-col cols="12" md="8" lg="6">
        <b-img src="@/assets/4788.svg" fluid-grow alt="Fluid-grow image"></b-img>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
 import VueRouter from 'vue-router';
 import Vue from 'vue'
 Vue.use(VueRouter)

  export default {
   
    data() {
      return {
        municipioIn: "",
        domain : window.location.toString()
      }
    },
    methods: {
      goLogin(){
        this.$router.push("/"+this.municipioIn.trim().toLowerCase()+'/login');
      }
    }
  }
</script>
<style>

</style>